import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useChat } from "@/contexts/ChatContext";
import {
  ConversationsList, ChatWindow, NewConversationModal,
} from "@/components/chat/ChatComponents";
import { ArrowLeft } from "@phosphor-icons/react";

export default function ChatPage() {
  const { user } = useAuth();
  const { conversations, refreshConversations } = useChat();
  const [active, setActive] = useState(null);
  const [newOpen, setNewOpen] = useState(false);
  const location = useLocation();
  const desiredConvId = location.state?.conversationId;

  // Cuando llegan nuevos datos, sincronizar la conversación activa
  useEffect(() => {
    if (!active) return;
    const fresh = conversations.find((c) => c.id === active.id);
    if (fresh) setActive(fresh);
  }, [conversations, active?.id]);

  // Si venimos con un conversationId desde otra página, abrirlo
  useEffect(() => {
    if (!desiredConvId || conversations.length === 0) return;
    const target = conversations.find((c) => c.id === desiredConvId);
    if (target) setActive(target);
  }, [desiredConvId, conversations]);

  // Auto-seleccionar General al entrar (si no se ha pedido otra)
  useEffect(() => {
    if (active || conversations.length === 0 || desiredConvId) return;
    const general = conversations.find((c) => c.type === "general") || conversations[0];
    if (general) setActive(general);
  }, [conversations, active, desiredConvId]);

  const onCreated = async (conv) => {
    await refreshConversations();
    setActive(conv);
  };

  return (
    <div className="flex-1 flex h-[calc(100vh-3rem)] md:h-screen min-h-0" data-testid="chat-page">
      {/* Lista (oculta en móvil cuando hay activa) */}
      <div className={`w-full md:w-80 border-r border-border ${active ? "hidden md:flex" : "flex"} flex-col min-h-0`}>
        <ConversationsList
          conversations={conversations}
          activeId={active?.id}
          onSelect={setActive}
          onNew={() => setNewOpen(true)}
          currentUserId={user.id}
        />
      </div>

      {/* Ventana */}
      <div className={`flex-1 flex-col min-w-0 ${active ? "flex" : "hidden md:flex"}`}>
        {active && (
          <button
            onClick={() => setActive(null)}
            className="md:hidden flex items-center gap-1.5 text-xs font-semibold px-3 py-2 border-b border-border text-brand"
            data-testid="chat-back-btn"
          >
            <ArrowLeft className="w-4 h-4" weight="bold" /> Conversaciones
          </button>
        )}
        <ChatWindow
          conversation={active}
          onConversationChanged={(c) => setActive(c)}
          key={active?.id || "empty"}
        />
      </div>

      <NewConversationModal
        open={newOpen}
        onOpenChange={setNewOpen}
        onCreated={onCreated}
      />
    </div>
  );
}
